/**
  * 历史的今天 接口的出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const history = {
    // 列表
    list(params) {
        return axios.get(api + 'history/list', { params: params })
    },
    //添加
    create(params) {
        return axios.post(api + 'history/create', qs.stringify(params))
    },
    //获取编辑信息
    detail(params) {
        return axios.post(api + 'history/detail', qs.stringify(params))
    },
    //修改
    edit(params) {
        return axios.post(api + 'history/edit', qs.stringify(params))
    },
    //删除
    remove(params) {
        return axios.post(api + 'history/remove', qs.stringify(params))
    },
    //状态
    status(params) {
        return axios.post(api + 'history/status', qs.stringify(params))
    },
    // 评论列表
    commentlist(params) {
        return axios.get(api + 'history/commentlist', { params: params })
    },
    //评论状态
    commentstatus(params) {
        return axios.post(api + 'history/commentstatus', qs.stringify(params))
    },
}


// 导出接口
export default history